import { useEffect } from "react";
import apiService from "services/apiService";
import clientTrace from "services/clientTraceService";
import { ExceptionHandlingType } from "types/apiServiceTypes";

const START_DELAY_MS = 1500;

export default function useClientTrace(userId?: string) {
  useEffect(() => {
    if (!userId) {
      return;
    }

    const timer = window.setTimeout(() => {
      void clientTrace.ensure(userId, async (requestId) => {
        await apiService.post(
          "/client-signals",
          { requestId },
          { exceptionHandlingType: ExceptionHandlingType.SILENT }
        );
      });
    }, START_DELAY_MS);

    return () => window.clearTimeout(timer);
  }, [userId]);
}
